import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { EventTracker } from './GoogleAnalytics';

import logo from '../logo.png';
import nyc from '../nyc_white.png';
import divider from '../upper-header-divider.gif';
import '../styles/navbar.scss';
import { Nav, Navbar, Container, Button } from 'react-bootstrap';

export default function Navigation({ l, setLang, availableLanguages, currentLang }) {

    if (l.nav.length === 0) {
        return (
            <>
                <div className="fixed-top">
                    <Container fluid className="Navigation p-0">
                        <OfficialSiteNav l={l} />
                    </Container>
                </div>
                <Container fluid className="Navigation p-0">
                    <Translation
                        setLang={setLang}
                        availableLanguages={availableLanguages}
                        currentLang={currentLang} />
                </Container>
            </>
        )
    }
    return (
        <>
            <div className="fixed-top">
                <Container fluid className="Navigation p-0">
                    <OfficialSiteNav l={l} />
                    <div className="bg-white">
                        <LocalSiteNav l={l} />
                    </div>
                </Container>
            </div>
            <Container fluid className="Navigation p-0">
                <Translation
                    setLang={setLang}
                    availableLanguages={availableLanguages}
                    currentLang={currentLang} />
            </Container>
        </>
    )
}

function OfficialSiteNav({ l }) {
    return (
        <Navbar className="Navbar container-top nyc-gov d-none d-lg-flex justify-content-between px-3">
            <span class="">
                <a href="http://www1.nyc.gov">
                    <img src={nyc} alt="NYC" class="small-nyc-logo" />
                </a>
                <img src={divider} alt="" />
                <span class="upper-header-black-title">
                    <a href="https://nyc.gov/cto">Mayor's Office of the Chief Technology Officer</a>
                </span>
            </span>
            <span class="">
                <span class="upper-header-black-title">
                    <a href="/311/index.page">311</a>
                </span>
                <img src={divider} alt="" />
                <span class="upper-header-black-title">
                    <a href="/home/search/index.page">Search all NYC.gov websites</a>
                </span>
            </span>
        </Navbar>
    )
}

function LocalSiteNav({ l }) {
    let location = useLocation();
    const currentLocation = location.pathname;
    const category = 'apply';
    const action = `clicked apply button in Navbar on ${currentLocation}`;
    return (
        <Navbar className="Navbar local-nav" collapseOnSelect expand="xl">
            <Navbar.Brand className="ml-3 d-none d-lg-block" href="https://nyc.gov/cto">
                <img
                    src={logo}
                    height="50"
                    className="d-inline-block align-top"
                    alt="NYC Mayor's Office of the Chief Technology Officer"
                />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <div className="ml-1 mr-auto mb-0 h4 d-flex d-lg-none align-items-center">
                Menu
            </div>
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="ml-auto align-items-start align-items-lg-center">
                    {l.nav.map((nav, i) => (
                        <Nav.Link
                            key={`nav-${i}`}
                            as={Link}
                            to={nav.url}
                            className={'.' + currentLocation === nav.url ? 'h4 bold mr-3 active' : 'h5 mr-3'}
                            eventKey={i}>
                            {nav.title}
                        </Nav.Link>
                    ))}
                    <Nav.Link
                        href={l.applyLink}
                        className="btn btn-primary mt-1 mt-lg-0"
                        eventKey={'apply'}
                        onClick={() => EventTracker(category, action)}>
                        {l.ctaButtonText}
                    </Nav.Link>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    )
}

function Translation({ setLang, availableLanguages, currentLang }) {
    const changeLang = (lang) => {
        EventTracker('Language', `Changed language to ${lang}`)
        setLang(lang);
    }
    return (
        <div className="Navigation__translate d-flex justify-content-end mr-2">
            {availableLanguages.length > 1 && availableLanguages.map(lang => (
                <Button
                    onClick={() => changeLang(lang)}
                    active={lang === currentLang}
                    key={`translate-${lang}`}>
                    <span className="text-uppercase">{lang}</span>
                </Button>
            ))}
        </div>
    )
}